import PropTypes from 'prop-types';
import React from 'react';

// components
import { Link } from 'react-router';

// images
import successImage from '../../assets/images/success';

const New3 = function() {
  return (
    <div className='rep-new__signup__step3'>
      <h2 className='panel__heading'>
        You're all set! Let's take a look at the current open books.
      </h2>
      <img className='rep-new__signup__success' src={ successImage } />
      <div className='form'>
        <div className='form__submit'>
          <Link className='form__button form__button--green' to='/reps/books'>View Open Books</Link>
        </div>
      </div>
    </div>
  );
};

New3.propTypes = {
  onNextStep: PropTypes.func.isRequired
};

export default New3;



// WEBPACK FOOTER //
// ./app/components/reps/_New3.jsx